var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1142_19489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2018 26.2199C41.4716 32.7277 36.1931 31.9766 36.0852 31.9694C35.2168 31.9048 34.3952 31.7862 33.5124 31.4196C32.6279 31.0531 31.8584 30.5213 31.1986 29.8241C29.967 28.5197 29.2658 26.8685 29.0932 24.8669C29.0645 24.5417 29.0501 24.2057 29.0501 23.8625V13.1108C29.0501 11.6069 28.8128 10.4247 28.3345 9.56225C27.8581 8.69982 27.2918 8.2668 26.6373 8.25962C25.9829 8.25423 25.5514 8.68005 25.3447 9.5353C25.2817 9.77966 25.253 10.0546 25.253 10.36V24.8669H14.8469V13.1108C14.8469 11.6069 14.5862 10.4247 14.0666 9.56225C13.547 8.69982 12.9807 8.2686 12.3694 8.2686C11.3895 8.2686 10.9005 9.05737 10.9005 10.6349V24.8669H0V2.06983H6.01929L8.64419 5.62739C9.53594 4.28342 10.8124 3.21077 12.4701 2.40942C14.1277 1.60807 15.8195 1.2074 17.5437 1.2074C19.7838 1.2074 21.6374 1.96562 23.1045 3.48207C23.5827 3.97079 23.9855 4.54036 24.3163 5.18898C26.3964 2.53519 29.0393 1.2074 32.2449 1.2074C33.1259 1.2074 34.0338 1.39067 34.9687 1.759C35.9054 2.12553 36.7216 2.65737 37.4192 3.35451C38.7245 4.65894 39.4688 6.31015 39.6504 8.30992C39.6809 8.63513 39.6953 8.97113 39.6953 9.3143V22.3479C39.6953 22.7881 39.6719 23.3469 39.7295 23.8679C39.8194 24.6854 40.7363 25.149 41.4285 24.707C41.4411 24.6998 41.4518 24.6926 41.4608 24.6854C42.0397 24.2578 42.5234 23.8536 42.8865 23.5337C43.3666 23.1115 43.6363 22.833 43.6363 22.833C43.6363 22.833 44.6089 24.1177 46.2 26.2199H46.2018Z",
    fill: "#985BEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1142_19489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/memo.b3712f5b468dc806aabc76524f1f65d7.svg";
export { ForwardRef as ReactComponent };